import { type FetchLike, trimTrailingSlash } from 'ProdantixSdk/core/http';
import type { ReplayChunk } from 'ProdantixSdk/web/replay/types';

export interface ReplayUploadOptions {
  apiKey: string;
  fetch: FetchLike;
  replayHost: string;
}

/** Uploads one chunk to the recorder (`POST {replayHost}/v1/replay`). The project key
 *  is sent as a Bearer token — the recorder's auth layer resolves it to a tenant and
 *  never trusts a project id in the body. Resolves to whether the server accepted it
 *  (202); the caller decides whether to retry. */
export async function uploadChunk(chunk: ReplayChunk, options: ReplayUploadOptions): Promise<boolean> {
  const url = `${trimTrailingSlash(options.replayHost)}/v1/replay`;
  const response = await options.fetch(url, {
    body: JSON.stringify(chunk),
    headers: {
      authorization: `Bearer ${options.apiKey}`,
      'content-type': 'application/json',
    },
    method: 'POST',
  });
  return response.ok;
}
